
            const data = {"name":"icon-arrow-slider","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M10.807 31.575a1.068 1.068 0 01-1.704-1.284l10.699-14.198a1.068 1.068 0 011.704 1.284L10.807 31.575z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M21.506 16.093a1.066 1.066 0 11-1.704 1.284L9.103 3.179a1.066 1.066 0 111.704-1.284l10.699 14.198z\"/>"}}
        
                module.exports = data
                